import { render, staticRenderFns } from "./CampaignsSchedule.vue?vue&type=template&id=24125cec&lang=pug"
import script from "./CampaignsSchedule.vue?vue&type=script&lang=js"
export * from "./CampaignsSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports